import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const TermsEditor = ({ content, onChange, onSave, isSaving }) => {
  const [activeFormat, setActiveFormat] = useState(null);

  const formatButtons = [
    { icon: 'Bold', label: '굵게', format: 'bold' },
    { icon: 'Italic', label: '기울임', format: 'italic' },
    { icon: 'Underline', label: '밑줄', format: 'underline' },
    { icon: 'List', label: '글머리 기호', format: 'bullet' },
    { icon: 'ListOrdered', label: '번호 매기기', format: 'numbered' },
    { icon: 'Heading1', label: '제목 1', format: 'h1' },
    { icon: 'Heading2', label: '제목 2', format: 'h2' },
    { icon: 'Heading3', label: '제목 3', format: 'h3' },
  ];

  const handleFormat = (format) => {
    setActiveFormat(format);
    setTimeout(() => setActiveFormat(null), 200);
  };

  return (
    <div className="rounded-lg bg-card shadow-card">
      <div className="border-b border-border p-4">
        <h2 className="text-lg font-semibold text-foreground">약관 내용 편집</h2>
        <p className="mt-1 text-sm text-muted-foreground">
          약관 내용을 작성하고 서식을 지정하세요
        </p>
      </div>
      <div className="border-b border-border p-3">
        <div className="flex flex-wrap gap-1">
          {formatButtons?.map((btn) => (
            <button
              key={btn?.format}
              onClick={() => handleFormat(btn?.format)}
              className={`flex h-9 w-9 items-center justify-center rounded-md transition-all duration-150 ease-out hover:bg-muted ${
                activeFormat === btn?.format ? 'bg-primary text-primary-foreground' : 'text-foreground'
              }`}
              title={btn?.label}
              aria-label={btn?.label}
            >
              <Icon name={btn?.icon} size={18} />
            </button>
          ))}
        </div>
      </div>
      <div className="p-4">
        <textarea
          value={content}
          onChange={(e) => onChange(e?.target?.value)}
          className="min-h-[400px] w-full rounded-md border border-input bg-muted px-3 py-2 text-sm text-foreground placeholder:text-muted-foreground focus:border-ring focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2"
          placeholder="약관 내용을 입력하세요..."
        />
      </div>
      <div className="border-t border-border p-4">
        <div className="flex items-center justify-between">
          <p className="text-sm text-muted-foreground">
            마지막 저장: {new Date()?.toLocaleString('ko-KR')}
          </p>
          <Button
            variant="default"
            onClick={onSave}
            loading={isSaving}
            iconName="Save"
            iconPosition="left"
          >
            저장
          </Button>
        </div>
      </div>
    </div>
  );
};

export default TermsEditor;